import dynamic from 'next/dynamic';

const componentRegistry = {
  BrandImageBanner: dynamic(() => import('./BrandImageBanner'), { ssr: false }),
  SingleImageSidebar: dynamic(() => import('./SingleImageSidebar'), { ssr: false }),
  BrandLeftImageWithDescription: dynamic(
    () => import('./BrandLeftImageWithDescription'),
    { ssr: false }
  ),
  BrandRightImageWithDescription: dynamic(
    () => import('./BrandRightImageWithDescription'),
    { ssr: false }
  ),
  BGImageWithHeadingAndSubHeading: dynamic(
    () => import('./BGImageWithHeadingAndSubHeading'),
    { ssr: false }
  ),
  ProductSlider: dynamic(() => import('./ProductSlider'), { ssr: false }),
  ThreeCardWithImageAndDescription: dynamic(
    () => import('./ThreeCardWithImageAndDescription'),
    { ssr: false }
  ),
  BigBrandImageBanner: dynamic(() => import('./BigBrandImageBanner'), { ssr: false }),
  ThreeProductWithHeading: dynamic(() => import('./ThreeProductWithHeading'), { ssr: false }),
  PrductDescriptionWithAddTocart: dynamic(
    () => import('./ProductDescriptionWithAddToCart'), { ssr: false }
  ),
  ImageSliderWithHeadingAndDescription: dynamic(
    () => import('./ImageSliderWithHeadingAndDescription'),
    { ssr: false }
  ),
  GridTwoImage: dynamic(() => import('./GridTwoImage'), { ssr: false }),
  GridThreeImage: dynamic(() => import('./GridThreeImage'), { ssr: false }),
  GridFourImage: dynamic(() => import('./GridFourImage'), { ssr: false }),
  BigVideo: dynamic(() => import('./BigVideo'), { ssr: false }),
  BlogComponent: dynamic(() => import('./BlogComponent'), { ssr: false }),
  ReviewComponent: dynamic(() => import('./ReviewComponent'), { ssr: false }),
  // Add other components as needed
};

export default componentRegistry;
